
export const defaultLocale = "th";
export const currency = "THB";
export const localeOptions=[
    {id:'th',name:'Thai'},    
    {id:'en',name:'English'}
];
